import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "announcement-meta"
};
const _hoisted_2 = {
  class: "announcement-popup-title"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  key: 0,
  class: "announcement-pager"
};
const _hoisted_5 = {
  class: "announcement-popup-footer"
};
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getPopups, hasDismissed, remember, noticeDate, noticeBody } from '../services/announcements';
import { isGuidePreview } from '../data/guide-preview';
export default {
  __name: 'AnnouncementPopup',
  setup(__props) {
    const router = useRouter(),
      queue = ref([]),
      index = ref(0),
      visible = ref(false),
      current = computed(() => queue.value[index.value]);
    const region = s => ({
      leo: '狮子座',
      gemini: '双子座',
      all: '全部区服'
    })[s];
    function dismiss() {
      remember(queue.value);
    }
    function close() {
      remember(queue.value, true);
      visible.value = false;
    }
    function detail() {
      if (!current.value) return;
      remember([current.value], true);
      router.push('/announcements/' + current.value.id);
      dismiss();
      visible.value = false;
    }
    onMounted(async () => {
      if (isGuidePreview) return;
      try {
        queue.value = (await getPopups()).filter(n => !hasDismissed(n));
        visible.value = queue.value.length > 0;
      } catch {/* A failed reminder must not block the site. */}
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => visible.value = $event),
        class: "announcement-dialog",
        title: "公告提醒",
        width: "min(700px, calc(100vw - 32px))",
        "close-on-click-modal": false,
        onClose: dismiss
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: detail
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("查看完整公告")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: close
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(queue.value.length > 1 ? '以上公告已知晓' : '我知道了'), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [current.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", {
          class: _normalizeClass(["announcement-type", 'announcement-type--' + current.value.kind])
        }, _toDisplayString(current.value.kind === 'game' ? '游戏公告' : '站内公告'), 3), _createElementVNode("span", null, _toDisplayString(_unref(noticeDate)(current.value)), 1), _createElementVNode("span", null, _toDisplayString(region(current.value.server)), 1)]), _createElementVNode("h2", _hoisted_2, _toDisplayString(current.value.title), 1), _createElementVNode("div", {
          class: "announcement-body announcement-popup-body",
          innerHTML: _unref(noticeBody)(current.value.body, current.value.kind)
        }, null, 8, _hoisted_3), queue.value.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_button, {
          disabled: index.value === 0,
          onClick: _cache[0] || (_cache[0] = $event => index.value--)
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("上一条")])),
          _: 1
        }, 8, ["disabled"]), _createElementVNode("span", null, _toDisplayString(index.value + 1) + " / " + _toDisplayString(queue.value.length), 1), _createVNode(_component_el_button, {
          disabled: index.value === queue.value.length - 1,
          onClick: _cache[1] || (_cache[1] = $event => index.value++)
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("下一条")])),
          _: 1
        }, 8, ["disabled"])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};